const identationForLine = (firstLine: string) => {
  let indentationEnd = 0
  while (
    indentationEnd < firstLine.length &&
    (firstLine[indentationEnd] === ' ' || firstLine[indentationEnd] === '\t')
  ) {
    indentationEnd++
  }
  if (indentationEnd === 0) return ''
  return firstLine.substring(0, indentationEnd)
}
const identLines = (lines: string[], targetIdentation = '') => {
  while (lines.length > 0 && lines[0].trim() === '') {
    lines.splice(0, 1)
  }
  if (lines.length === 0) return ''
  //remove as últimas linhas vazias
  while (lines.length > 0 && lines[lines.length - 1].trim() === '') {
    lines.splice(lines.length - 1, 1)
  }

  if (lines.length == 0) return

  //detect indentation from first line
  const firstLine = lines[0]
  const indentation = identationForLine(firstLine)

  if (indentation.length > 0 || targetIdentation?.length > 0) {
    const identationLength = indentation.length
    for (let i = 0; i < lines.length; i++) {
      const l = lines[i]
      lines[i] = targetIdentation + (l.indexOf(indentation) === 0 ? l.substring(identationLength) : l)
    }
  }
}

const t = (literals: TemplateStringsArray, ...expressions: string[]) => {
  const lines: string[] = ['']
  for (let i = 0; i < literals.length; i++) {
    const literalLines = literals[i].split('\n')
    lines[lines.length - 1] = lines[lines.length - 1] + literalLines.splice(0, 1)
    if (i < expressions.length && expressions[i] != null) {
      const expressionLines = expressions[i].split('\n')

      if (literalLines.length == 0) {
        lines[lines.length - 1] = lines[lines.length - 1] + expressionLines.splice(0, 1)
        lines.push(...expressionLines)
      } else {
        //checks if there is need to ident all the expression content
        const lastLineIdentation = identationForLine(literalLines[literalLines.length - 1])
        const lastLineIsIdentation = lastLineIdentation == literalLines[literalLines.length - 1]
        if (lastLineIsIdentation && expressionLines?.length > 1) {
          identLines(expressionLines, lastLineIdentation)
          literalLines.splice(literalLines.length - 1, 1)
          lines.push(...literalLines)
          lines.push(...expressionLines)
        } else {
          literalLines[literalLines.length - 1] = literalLines[literalLines.length - 1] + expressionLines.splice(0, 1)
          lines.push(...literalLines)
          if (expressionLines.length > 0) lines.push(...expressionLines)
        }
      }
    } else {
      lines.push(...literalLines)
    }
  }

  identLines(lines, '')
  return lines.join('\n')
}

export default t
